<template>
  <div class="relative overflow-hidden" :style="frameStyle">
    <video
      class="absolute top-0 left-0 max-w-none"
      :style="videoStyle"
      loop muted autoplay crossorigin playsinline
    >
      <source :src="webmSrc" type="video/webm"/>
      <source :src="mp4Src" type="video/mp4"/>
    </video>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  webmSrc: String,
  mp4Src: String,
  source: {
    type: String,
    required: true,
  },
  crop: {
    type: String,
    required: true,
  },
});

const numbers = (value) => value.split(':').map(Number);

const frameStyle = computed(() => {
  const [w, h] = numbers(props.crop);
  return { aspectRatio: `${w} / ${h}` };
});

const videoStyle = computed(() => {
  const [sw, sh] = numbers(props.source);
  const [cw, , x, y] = numbers(props.crop);
  return {
    width: `${(sw / cw) * 100}%`,
    transform: `translate(${(-x / sw) * 100}%, ${(-y / sh) * 100}%)`,
  };
});
</script>
